import { api } from "./api"

export const SAVE_PAYMENT_METHOD = async (type: string, params : any) => {
    const {data} = await api.post(`/payments/methods/change/${type}`, params)
    return data;
}

export const GET_PLANS = async () => {
    const {data} = await api.get(`/payments/plans/list`)
    return data || [];
}

